import { ca } from '@cian/analytics';

import { TOffer } from '../../types/offer';
import { getProducts } from '../../utils/trackings_helpers';

export function trackContextMenuClick(offer?: TOffer, opponentId?: number) {
  ca('eventSite', {
    action: 'context_menu_sopr',
    category: 'Chat',
    label: 'click',
    name: 'oldevent',
    products: offer ? getProducts([offer]) : [],
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}

export function trackContextMenuMoveToArchiveClick(offer?: TOffer, opponentId?: number) {
  ca('eventSite', {
    action: 'context_menu_sopr',
    category: 'Chat',
    label: 'archive',
    name: 'oldevent',
    products: offer ? getProducts([offer]) : [],
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}

export function trackContextMenuMarkAsReadClick(offer?: TOffer, opponentId?: number) {
  ca('eventSite', {
    action: 'context_menu_sopr',
    category: 'Chat',
    label: 'read',
    name: 'oldevent',
    products: offer ? getProducts([offer]) : [],
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}

export function trackContextMenuDeleteClick(offer?: TOffer, opponentId?: number) {
  ca('eventSite', {
    action: 'context_menu_sopr',
    category: 'Chat',
    label: 'delete',
    name: 'oldevent',
    products: offer ? getProducts([offer]) : [],
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}

export function trackContextMenuUnblockClick(offer?: TOffer, opponentId?: number) {
  ca('eventSite', {
    action: 'context_menu_sopr',
    category: 'Chat',
    label: 'unblock',
    name: 'oldevent',
    products: offer ? getProducts([offer]) : [],
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}

export function trackContextMenuRemoveFromArchiveClick(offer?: TOffer, opponentId?: number) {
  ca('eventSite', {
    action: 'context_menu_sopr',
    category: 'Chat',
    label: 'restore',
    name: 'oldevent',
    products: offer ? getProducts([offer]) : [],
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}
